import { tabValues } from './useActiveTab';
import useAchievements from '@/hooks/useAchievements';
import { useMemo } from 'react';


export const useUnlockedTabs = (): (typeof tabValues)[number][] => {
    const defaultUnlockedTabs = useMemo<(typeof tabValues)[number][]>(() => ['calendar', 'collections'], []);

    const { score } = useAchievements();

    const addedUnlockedTabs = useMemo(() => {
        const addedUnlockedTabs: (typeof tabValues)[number][] = [];

        // Unlock the achievements tab if a user has a high enough score to know how the app works
        if (score >= 100)
            addedUnlockedTabs.push('achievements');

        return addedUnlockedTabs;
    }, [score]);

    const allUnlockedTabs = useMemo(() => {
        return [...defaultUnlockedTabs, ...addedUnlockedTabs];
    }, [defaultUnlockedTabs, addedUnlockedTabs]);

    return allUnlockedTabs;
};
